module.exports = __webpack_public_path__ + "static/media/citrus_color_orange.2e2a9fa1.svg";